// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__nOc2k","title":"Modal_title__h7mor","text":"Modal_text__CmyXO","button":"Modal_button__PplGw"};